import { AnimatePresence, motion } from "motion/react";
import type React from "react";
import { useTranslation } from "react-i18next";
import { BlockButton as UntypedBlockButton } from "../../inJoy-components/Button/BlockButton";

const _BlockButton = UntypedBlockButton as any;

interface StickyCountdownBarProps {
	isVisible: boolean;
	timeLeft?: string;
	onPlayNow: () => void;
}

export const StickyCountdownBar: React.FC<StickyCountdownBarProps> = ({
	isVisible,
	timeLeft = "5:30",
	onPlayNow,
}) => {
	const { t } = useTranslation();

	return (
		<AnimatePresence>
			{isVisible && (
				<motion.div
					initial={{ y: -100, opacity: 0 }}
					animate={{ y: 0, opacity: 1 }}
					exit={{ y: -100, opacity: 0 }}
					transition={{ type: "spring", stiffness: 300, damping: 30 }}
					className="fixed top-0 left-0 right-0 z-50 flex justify-center pointer-events-none"
				>
					<div className="bg-white rounded-b-[8px] shadow-[0px_4px_12px_0px_rgba(0,0,0,0.08)] flex items-center justify-between px-[20px] py-[12px] w-full pointer-events-auto gap-[12px]">
						<div className="flex flex-col items-start">
							<p className="font-medium text-[12px] tracking-[1.5px] text-color_text_grey_3 uppercase leading-[1.25]">
								{t("guest.landing.next_game_starts")}
							</p>
							<p className="font-semibold text-[28px] text-color_text_grey_5 leading-[1.2] tracking-[-0.5px]">
								{timeLeft}
							</p>
						</div>

						<button
							onClick={onPlayNow}
							className="bg-color_background_primary_3 text-white text-[14px] font-medium leading-[1.25] px-[16px] py-[8px] rounded-[24px] shrink-0 active:opacity-90 transition-opacity"
						>
							{t("guest.landing.play_now")}
						</button>
					</div>
				</motion.div>
			)}
		</AnimatePresence>
	);
};
